import { Injectable } from '@angular/core';
import {
  DataModel,
  MetaModel,
  WidgetModel,
} from 'common/models/utility-models/base-model';
import { FormWidgetService } from '../form-widget.service';
import { SystemService } from 'common/services/core-services/system.service';
import { CompanyFormDataService } from 'common/services/data-services/admin/internship-company/comapny-form-data.service';

import { SmMetaModel } from 'common/models/utility-models/meta-model';
import { CompanyModel } from 'common/models/page-models/internship-company/internship-company/internship-company-data.model';
import { CompanyMetaModel } from 'common/models/page-models/internship-company/internship-company/internship-company-form-meta.model';

@Injectable({
  providedIn: 'root',
})
export class CompanyFormWidgetService extends FormWidgetService<CompanyModel> {
  constructor(protected ds: CompanyFormDataService, private ss: SystemService) {
    super(ds);
  }

  getMetaModel(): MetaModel {
    const meta = new CompanyMetaModel();
    return meta.getMetaModel();
  }
  override prepareMetaModel(
    dataModel: CompanyModel,
    metaModel: CompanyMetaModel,
    routeData: WidgetModel
  ): Promise<SmMetaModel> {
    return new Promise<SmMetaModel>((resolve, reject) => {
      metaModel.pageTitle = dataModel.internshipCompanyId !== '' ? 'Update Company' : 'Add Company';
      const startYear = 2022;
            const endYear = new Date().getFullYear();
            // const endYear = 2030;
            const yearOptions = [];
            for (let year = startYear; year <= endYear; year++) {
                yearOptions.push({
                value: `${year}`,
                name: year
                });
            }
            metaModel.properties['year'].options = yearOptions;
      resolve(metaModel);
    });
  }


  // Save(body, url) {
  //     this.ds.postLocationData(body, url).then((response) => {
  //       if (response.header.type === 'success') {
  //         this.ss.showSuccess(response.header.msg);
  //       }
  //     });
  //   }
}
